import {useState} from 'react';
import {I18n} from '@aws-amplify/core';

import {FormDrawer} from './FormDrawer';
import {buildUpdateInput} from '../forms/buildInput';
import {buildInitialValues} from '../forms/buildInitialValues';
import {useUpdateProductMutation} from '../hooks/useProductsQuery';
import {Product} from '../types';

type EditFormDrawerProps = {
    record: Product,
    opened: boolean,
    onClose: () => void,
};

export const EditFormDrawer = ({record, opened, onClose}: EditFormDrawerProps) => {

    const {mutateAsync} = useUpdateProductMutation();
    const [initialValues] = useState(() => buildInitialValues(record));

    return (
        <FormDrawer
            title={I18n.get('Edit product')}
            initialValues={initialValues}
            // expectedVersion is the version this record was READ at.
            handleSubmit={(values) => mutateAsync(buildUpdateInput(record, values))}
            opened={opened}
            onClose={onClose}
        />
    );
};
